import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { LocalstorageService } from '@services/localstorage.service';
import { AuthService } from 'src/app/services/auth.service';

export const authGuard: CanActivateFn & CanMatchFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const localstorageService = inject(LocalstorageService);

  const token = localstorageService.getProperty('token');
  if (token?.jwt) {
    return true;
  } else {
    authService.signout();
    localstorageService.clearLocalStorageItem('token');
    return router.createUrlTree(['']);
  }
};
